<template>
    <v-container id="checkout-form-wrapper">
        <v-row v-show="isLoggedIn" column justify-center align-center>
            <v-col cols="12" md="12" class="py-0" v-show="!isCustomerConnected">
                <v-alert color="primary" elevation="2" type="warning" dense>
                    <div class="d-flex align-center">
                        <TranslatableStringComponent :tstring="{string: 'existingCustomer'}" />
                        <TranslatableStringComponent :tstring="{string: 'connectToYourCustomerAccount'}" />
                        <v-btn
                            color="white"
                            class="ml-2"
                            small
                            light
                            @click="showModal = true"
                            ><TranslatableStringComponent :tstring="{string: 'connect'}" /></v-btn
                        >
                    </div>
                </v-alert>
            </v-col>
            <v-col cols="12" md="8">
                <h2>
                    <TranslatableStringComponent :tstring="{string: 'billingShippingInformation'}" />
                </h2>
                <ContactCards />
                <OptionalFields />
            </v-col>
            <v-col cols="12" md="4">
                <h2><TranslatableStringComponent :tstring="{string: 'cartTotals'}" /></h2>
                <CartTotals :is-checkout="true" />
            </v-col>
        </v-row>
        <v-row v-show="!isLoggedIn" column justify-center align-center>
            <v-col cols="12">
                <FormLogin :heading="true" />
            </v-col>
        </v-row>
        <ConnectCustomerDialog
            :showModal="showModal"
            stepperValue="2"
            @handlePostCustomerConnect="handlePostCustomerConnect()"
            @handleDialog="showModal = false"
        />
    </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import OptionalFields from '~/components/OptionalFields'
import ContactCards from '~/components/ContactCards'
import FormLogin from '~/components/forms/FormLogin.vue'
import CartTotals from '~/components/CartTotals.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
import handleAuth from '~/mixins/handleAuth'
import ConnectCustomerDialog from '~/components/ConnectCustomerDialog.vue'
import handleSnackbar from '~/mixins/handleSnackbar'

export default {
    name: 'FormCheckout',
    components: {
        ContactCards,
        CartTotals,
        FormLogin,
        OptionalFields,
        ConnectCustomerDialog,
        TranslatableStringComponent,
    },
    mixins: [handleAuth, handleSnackbar],
    data() {
        return {
            cart: [],
            isCart: false,
            isCheckout: true,
            showModal: false,
        }
    },
    computed: {
        ...mapState('flag', ['isResetForm']),
        ...mapState('checkout', ['billingFormArray']),
        ...mapGetters({
            subtotal: 'cart/fetchCartSubtotal',
            cartProducts: 'cart/fetchCartProducts',
            isCustomerConnected: 'auth/isCustomerConnected',
            isLoggedIn: 'auth/isLoggedIn'
        }),
        showCheckoutButton() {
            return false
        },
    },
    methods: {
        handlePostCustomerConnect() {
            this.showModal = false
            this.hitSnackbar(
                { string: 'youAreNowConnectedToYourCustomerAccount' },
                null
            )
        },
    }
}
</script>
